<template>
  <v-dialog :value="show" max-width="600px">
    <v-card :loading="loading">
      <v-card-title>
        <span class="text-h5">Changer le mot de passe</span>
      </v-card-title>
      <v-card-text>
        <v-container v-if="etat == 1">
          <v-row>
            <v-col cols="12">
              <password-field
                v-model="oldPw"
                label="Ancien mot de passe"
                :error-messages="oldPwErrors"
                @input="$v.oldPw.$touch()"
                @blurPass="$v.oldPw.$touch()"
              ></password-field>
            </v-col>
            <v-col cols="12">
              <password-field
                v-model="newPw"
                label="Nouveau mot de passe"
                :error-messages="newPwErrors"
                @input="$v.newPw.$touch()"
                @blurPass="$v.newPw.$touch()"
              ></password-field>
            </v-col>
            <v-col cols="12">
              <password-field
                v-model="checkPw"
                label="Confirmation nouveau mot de passe"
                hint="Ressaisissez le nouveau mot de passe pour vérification"
                required
                :error-messages="checkPwErrors"
                @input="$v.checkPw.$touch()"
                @blurPass="$v.checkPw.$touch()"
              ></password-field>
            </v-col>
          </v-row>
        </v-container>
        <v-container v-if="etat == 2">
          Changement du mot de passe effectué avec succès.
        </v-container>
        <v-container v-if="etat == 3">
          Erreur lors du changement du mot de passe. Réessayez.
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn
          v-if="etat == 1"
          color="produit darken-1"
          text
          @click="save"
          :disabled="!readyToSave"
        >
          Enregistrer
        </v-btn>
        <v-btn color="blue darken-1" text @click="close"> Annuler </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import PasswordField from "@/components/PasswordField";
import FournisseurService from "@/services/FournisseurService";
import { required, sameAs } from "vuelidate/lib/validators";

export default {
  components: {
    PasswordField,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    passwordKind: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      newPw: "",
      oldPw: "",
      checkPw: "",
      loading: false,
      etat: 1,
    };
  },
  computed: {
    readyToSave() {
      return !this.$v.$invalid;
    },
    oldPwErrors() {
      const errors = [];
      if (!this.$v.oldPw.$dirty) return errors;
      !this.$v.oldPw.required && errors.push("Obligatoire");
      return errors;
    },
    newPwErrors() {
      const errors = [];
      if (!this.$v.newPw.$dirty) return errors;
      !this.$v.newPw.required && errors.push("Obligatoire");
      return errors;
    },
    checkPwErrors() {
      const errors = [];
      if (!this.$v.checkPw.$dirty) return errors;
      !this.$v.checkPw.required && errors.push("Obligatoire");
      !this.$v.checkPw.sameAs &&
        errors.push("Doît être identique au nouveau mot de passe");
      return errors;
    },
  },
  watch: {
    show() {
      if (this.show) {
        this.$v.$reset();
        this.oldPw = "";
        this.newPw = "";
        this.checkPw = "";
      }
    },
  },
  methods: {
    close() {
      this.$emit("hide");
      this.etat = 1;
    },
    save() {
      this.loading = true;
      FournisseurService.savePassword({
        PasswordKind: this.passwordKind,
        ActualPassword: this.oldPw,
        NewPassword: this.newPw,
      })
        .then((res) => {
          if (res.status == 204) {
            this.etat = 2;
          }
        })
        .catch((err) => {
          if (
            err.response &&
            err.response.status &&
            err.response.status == 401
          ) {
            this.$router.push({ name: "home" });
          } else {
            this.$store.dispatch("setErreur", err);
          }
          this.etat = 3;
        })
        .finally(() => {
          this.loading = false;
          setTimeout(() => {
            this.$emit("hide");
            this.etat = 1;
          }, 1250);
        });
    },
  },
  validations: {
    oldPw: {
      required,
    },
    newPw: {
      required,
    },
    checkPw: {
      required,
      sameAs: sameAs("newPw"),
    },
  },
};
</script>

<style></style>
